import { Button } from "@photo-booth/ui/button";
import { PageTransition } from "@/components/PageTransition";
import { useNavigate } from "react-router";
import { PrinterButton } from "@/components/PrinterButton";
import { HamburgerMenu } from "@/components/HamburgerMenu";
import { analyticsClick } from "@/lib/analytics/props";
import { useSEO } from "@/lib/seo/useSEO";
import {
  generateOrganizationSchema,
  generateWebSiteSchema,
} from "@/lib/seo/structuredData";

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  useSEO({
    title: "KeptScene Photo Booth - Create Beautiful Memories",
    description:
      "Start your photo booth experience with KeptScene. Choose from monthly frames, capture photos, and create stunning memories.",
    keywords: "photo booth, photo frames, KeptScene, photo capture",
    structuredData: [generateOrganizationSchema(), generateWebSiteSchema()],
  });

  return (
    <PageTransition>
      <div className="h-screen-safe-area bg-[url('/home-animation/aug/background.jpg')] bg-cover">
        {/* Header Section */}
        <HamburgerMenu onNavigate={handleNavigate} />

        {/* Main Photo Booth Section */}
        <main className="relative flex flex-col items-center justify-center md:py-12 lg:py-16">
          {/* Photo Booth Container */}
          <div className="relative w-full max-w-7xl mx-auto">
            {/* Background SVG */}
            <div
              className="w-full aspect-[7/12] bg-cover bg-no-repeat bg-center max-w-3xl"
              style={{
                backgroundImage: "url(/home-animation/aug/photobooth.gif)",
              }}
            >
              {/* Button Container - positioned over the photo booth */}
              <div className="relative w-full h-full">
                {/* START Button - positioned on the left side of the booth */}
                <div className="absolute top-[51%] left-[27%] md:left-[18%] lg:left-[16%] transform -translate-y-1/2">
                  <Button
                    className="text-sm font-family-reenie md:text-base lg:text-lg font-bold bg-background rounded-none py-[48px] px-[17px] text-vintage-red border-1 border-black button-shadow active:bg-vintage-red active:text-natural-white hover:bg-vintage-red hover:text-natural-white focus:bg-vintage-red focus:text-natural-white"
                    onClick={() => navigate("/photo-booth")}
                    {...analyticsClick({
                      event: "start-button",
                      feature: "navigation",
                      location: window.location.pathname,
                    })}
                  >
                    START
                  </Button>
                </div>

                {/* HOW TO USE Button - positioned below START button */}
                <div className="absolute top-[65%] md:top-[70%] left-[27%] md:left-[16%] lg:left-[14%]">
                  <PrinterButton />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </PageTransition>
  );
};
